<template>
	<div id="LegalDocumentModalComponent">
		<button v-show="1 == 2" class="btn-link" data-toggle="modal" data-target="#legalDocumentModalComponent" ref="btnShowLegalDocumentModalComponent" @click="btnShowLegalDocumentModalComponent">Nuevo Documento Legal</button>
		<button v-show="1 == 2" class="btn-link" ref="btnGetData" @click="getData">Nuevo Documento Legal</button>

		<div class="modal fade" id="legalDocumentModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog " :class="(searching) ? 'modal-sm' : 'modal-xl'">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Documento Electronico</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" v-show="!searching">
                        <blockquote id="datosErrores" class="alert alert-danger" v-show="errors">
                            <p class="text-danger">Existen <span></span> errores <a href="#" class="btn-link" style="float:right" @click="showErrors = !showErrors">Mostrar Errores</a></p>
                            <div class="display-errors" v-show="showErrors">
                                <ul>
                                    <li class="text-primary" v-show="(objectLegalDocument.issuing_entity_name.trim().length < 3)"> - <label>La Razón Social del Emisor debe tener como minimo 3 caracteres</label></li>
                                    <li class="text-primary" v-show="!checkDigitoRUT(objectLegalDocument.issuing_entity_document_number)"> - <label>El RUT del Emisor no es valido</label></li>
                                    <li class="text-primary" v-show="objectLegalDocument.issuing_entity_economic_activity.trim().length < 4"> - <label>Emisor sin Actividad Economica</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.issuing_entity_address_street.trim().length < 5)"> - <label>Emisor sin Dirección</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.issuing_entity_address_comuna.trim().length < 3)"> - <label>Emisor sin Comuna</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.receiving_entity_name.trim().length < 3)"> - <label>La Razón Social del Receptor debe tener como minimo 3 caracteres</label></li>
                                    <li class="text-primary" v-show="!checkDigitoRUT(objectLegalDocument.receiving_entity_document_number)"> - <label>El RUT del Receptor no es valido</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.receiving_entity_economic_activity.trim().length < 4)"> - <label>Receptor sin Actividad Economica</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.receiving_entity_address_street.trim().length < 5)"> - <label>Receptor sin Dirección</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.receiving_entity_address_comuna.trim().length < 3)"> - <label>Receptor sin Comuna</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.legal_document_references[0].type_legal_document_id == 0)"> - <label>No se ha elegido un tipo de documento en la referencia</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.legal_document_references[0].legal_document_number == 0)"> - <label>Son numero de Folio en la referencia</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.legal_document_references[0].date_legal_document == '')"> - <label>No ha seleccionado una fecha</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.legal_document_references[0].code_reference == 0)"> - <label>No se ha seleccionado motivo en la referencia </label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.legal_document_references[0].reason.trim().length < 5)"> - <label>Sin observacion en la referencia</label></li>
                                    <li class="text-primary" v-show="(objectLegalDocument.total != (objectLegalDocument.tax + objectLegalDocument.net))"> - <label>Hay incongruencias en los valores finales</label></li>
                                </ul>
                            </div>
                        </blockquote>						
                        <div class="row">
                            <label class="col-sm-2 control-label font-size-12">Tipo Documento</label>
                            <div class="col-sm-3">
                                <select class="input-12 border text-dark" data-width="100%" data-style="btn-info" id="typeLegalDocument" v-model="objectLegalDocument.type_legal_document_id">
                                    <option v-for="(item, index) in listTypeLegalDocuments" :key="index" :value="item.id" v-show="item.weGenerate">{{ item.name }}</option>
                                </select>
                            </div>
                            <label class="col-sm-1 control-label font-size-12">Fecha</label>
                            <div class="col-sm-3">
                                <div class='input-group date' id='FchEmis'>
                                    <input type='date' class="input-12 border text-dark" v-model="objectLegalDocument.date_legal_document"/>
                                </div>
                            </div>
                            <div class="col-sm-3 text-right font-size-12">
                                <a href="#" class="btn-link" id="mostraEmisor" @click="showIssuingEntity = !showIssuingEntity">Mostrar Emisor</a>
                            </div>
                        </div>
                        <div v-show="showIssuingEntity" id="datosEmisor">
                            <hr>
                            <div class="row">
                                <label class="col-sm-1 control-label font-size-12">Emisor</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityName" placeholder="Razon Social" disabled
                                                    :class="(objectLegalDocument.issuing_entity_name.trim().length < 3) ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_name"/>
                                </div>
                                <br>
                                <div class="col-sm-2">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityDocumentNumber" placeholder="RUT Emisor" disabled
                                                    :class="(!checkDigitoRUT(objectLegalDocument.issuing_entity_document_number)) ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_document_number"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityEconomicActivity" placeholder="Giro Emisor" disabled
                                                    :class="(objectLegalDocument.issuing_entity_economic_activity == '') ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_economic_activity"/>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-sm-1 control-label font-size-12">Dirección</label>
                                <div class="col-sm-5">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityAddressStreet" placeholder="Dirección" disabled
                                                    :class="(objectLegalDocument.issuing_entity_address_street == '') ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_address_street"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityAddressComuna" placeholder="Comuna" disabled
                                                    :class="(objectLegalDocument.issuing_entity_address_comuna == '') ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_address_comuna"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="issuingEntityAddressCity" placeholder="Ciudad" disabled
                                                    :class="(objectLegalDocument.issuing_entity_address_city == '') ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.issuing_entity_address_city"/>
                                </div>
                            </div>
                            <hr>
                        </div>
                        <hr>
                        <div id="datosReceptor">
                            <div class="row">
                                <label class="col-sm-1 control-label font-size-12" for="receivingEntityName" ref="receivingEntityName">Receptor</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityName" placeholder="Razon Social"
                                                    :class="(objectLegalDocument.receiving_entity_name.trim().length < 3) ? 'border-danger' : ''"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.receiving_entity_name" :readonly="readonlyReceivingEntityName"/>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityDocumentNumber" placeholder="Rut Receptor"
                                                    :class="(!checkDigitoRUT(objectLegalDocument.receiving_entity_document_number)) ? 'border-danger' : ''"
                                                    v-model="objectLegalDocument.receiving_entity_document_number"
                                                    @focus="$event.target.select()"
                                                    v-on:keyup.enter="getByReceivingEntityDocumentNumberLocal(objectLegalDocument.receiving_entity_document_number)"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityEconomicActivity" placeholder="Giro Receptor"
                                                    :class="(objectLegalDocument.receiving_entity_economic_activity == '') ? 'border-danger' : ''"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.receiving_entity_economic_activity"/>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <label class="col-sm-1 control-label font-size-12">Dirección</label>
                                <div class="col-sm-5" id="direccion">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityAddressStreet" placeholder="Direción Receptor"
                                                    :class="(objectLegalDocument.receiving_entity_address_street == '') ? 'border-danger' : ''"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.receiving_entity_address_street"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityAddressComuna" placeholder="Comuna Receptor"
                                                    :class="(objectLegalDocument.receiving_entity_address_comuna == '') ? 'border-danger' : ''"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.receiving_entity_address_comuna"/>
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="input-12 border text-dark" id="receivingEntityAddressCity" placeholder="Ciudad Receptor" 
                                                    :class="(objectLegalDocument.receiving_entity_address_city == '') ? 'border-danger' : ''"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.receiving_entity_address_city"/>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <label class="col-sm-1 control-label font-size-12">Contacto</label>
                                <div class="col-sm-5">
                                    <input type="text" class="input-12 border text-dark" id="conact" placeholder="Contacto"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.contact"/>
                                </div>
                                <label class="col-sm-1 control-label font-size-12">Telefono</label>
                                <div class="col-sm-2">
                                    <input type="text" class="input-12 border text-dark" id="phone" placeholder="Telefono"
                                                    @focus="$event.target.select()"
                                                    v-model="objectLegalDocument.phone"/>
                                </div>
                            </div>
                        </div>
                        <br>
                        <table class="table table-sm table-condensed table-striped table-hover table-12" id="listaDetalleMovimientoSiiDocumentoElectronico">
                            <thead>
                                <tr class="text-center">
                                    <th class="text-center">#</th>
                                    <th class="text-center">Código</th>
                                    <th class="text-center">Articulo</th>
                                    <th class="text-center">Cantidad</th>
                                    <th class="text-center">Prec. Uni.</th>
                                    <th class="text-center">Total Item</th>
                                </tr>
                                </thead>
                            <tbody>
                                <tr v-for="(item, index) in objectLegalDocument.legal_document_details" :key="index">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td class="text-center">{{ item.code }}</td>
                                    <td>{{ item.name }}</td>
                                    <td class="text-right">{{ methodFormatNumber(item.quantity) }}</td>
                                    <td class="text-right">{{ methodFormatNumber(item.price) }}</td>
                                    <td class="text-right">{{ methodFormatNumber(item.price * item.quantity) }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div id="datosTotales">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label class="font-size-12">Observación</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <textarea class="form-control" rows="3" id="A6" laceholder="Contacto"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <br>
                                    <div style="border:1px solid #ccc; padding-right:2px;">
                                        <div class="row">
                                            <div class="col-sm-3 text-right font-size-12">
                                                Exento: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right">
                                                <label id="MntExe">{{ methodFormatNumber(objectLegalDocument.exempt) }}</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                Neto: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                <label id="MntNeto">{{ methodFormatNumber(objectLegalDocument.net) }}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-3 text-right font-size-12">
                                                Descuento: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                <label id="MntDescuento">{{ methodFormatNumber(objectLegalDocument.discount) }}</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                IVA <span id="poriva"></span>%: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                <label id="IVA">{{ methodFormatNumber(objectLegalDocument.tax) }}</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-3 text-right font-size-12">
                                                Recargo: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                <label id="MntDescuento">{{ methodFormatNumber(objectLegalDocument.surcharge) }}</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                Total: <label>$</label>
                                            </div>
                                            <div class="col-sm-3 text-right font-size-12">
                                                <label class="control-label" id="MntTotal" :class="(objectLegalDocument.total != (objectLegalDocument.tax + objectLegalDocument.net)) ? 'text-danger': ''">{{ methodFormatNumber(objectLegalDocument.total) }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div id="datosReferencia font-size-12" v-show="needReference">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>Referencia</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <select class="input-12 border text-dark" data-width="100%" data-style="btn-info" id="TpoDocRef" v-model="objectLegalDocument.legal_document_references[0].type_legal_document_id">
                                        <option v-for="(item, index) in listTypeLegalDocuments" :key="index" :value="item.id">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-1">
                                    <input type="text" class="input-12 border text-dark" id="FolioRef" placeholder="Folio" v-model="objectLegalDocument.legal_document_references[0].legal_document_number"/>
                                </div>
                                <div class="col-sm-2">
                                    <div class='input-group date' id='FchRef'>
                                        <input type='date' class="input-12 border text-dark" v-model="objectLegalDocument.legal_document_references[0].date_legal_document"/>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <select class="input-12 border text-dark" data-width="100%" data-style="btn-info" id="CodRef" v-model="objectLegalDocument.legal_document_references[0].code_reference">
                                        <option value="1">Anula Documento</option>
                                        <option value="2">Corrige Texto</option>
                                        <option value="3">Corrige Montos</option>
                                    </select>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text" class="input-12 border text-dark" id="RazonRef" placeholder="Razón Referencia" v-model="objectLegalDocument.legal_document_references[0].reason"/>
                                </div>
                            </div>
                        </div>
					</div>
                    <div class="modal-body " role="alert" v-show="searching">
        				{{ msgSearching }}
                        <div class="spinner-border square-20 float-right" role="status">
                            <span class="sr-only">Cargando...</span>
                        </div>
                    </div>

					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" :disabled="errors || savingLegalDocument" v-show="isNew && !searching" @click="saveLegalDocumentLocal">
                            <span v-if="!savingLegalDocument">
                                Generar Documento Electronico
                            </span>
                            <span v-else>
                                Generando Documento Electronico
                                <div class="spinner-border square-20 float-right" role="status">
                                    <span class="sr-only">Cargando...</span>
                                </div>
                            </span>
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnCloseLegalDocumentModalComponent" @click="btnCloseLegalDocumentModalComponent">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
    import errors from '@/mixins/errors.js'
    import axiosAction from '@/mixins/axiosAction.js'
    import legalDocument from '@/mixins/legalDocuments'

	export default {
		name: 'LegalDocumentModalComponent',
        mixins: [axiosAction, errors, mixin, legalDocument],
        props: ['urlSearch', 'typeLegalDocumentsId'],
		data () {
			return {
                showIssuingEntity: false,
                showErrors: false,
                listTypeLegalDocuments: [
                    { id: 30, name: 'FACTURA', weGenerate: false, needReference: false},
                    { id: 32, name: 'FACTURA EXENTA', weGenerate: false, needReference: false},
                    { id: 33, name: 'FACTURA ELECTRONICA', weGenerate: true, needReference: false},
                    { id: 34, name: 'FACTURA EXENTA ELECTRONICA', weGenerate: false, needReference: false},
                    { id: 35, name: 'BOLETA', weGenerate: false, needReference: false},
                    { id: 38, name: 'BOLETA EXENTA', weGenerate: false, needReference: false},
                    { id: 39, name: 'BOLETA ELECTRONICA', weGenerate: true, needReference: false},
                    { id: 52, name: 'GUIA DE DESPACHO ELECTRONICA', weGenerate: true, needReference: false},
                    { id: 56, name: 'NOTA DE DEBITO ELECTRONICA', weGenerate: true, needReference: true},
                    { id: 61, name: 'NOTA DE CREDITO ELECTRONICA', weGenerate: true, needReference: true},
                ],
                dataReturn: {
                    table: '',
                    origenId: 0,
                    id: 0
                },
                searching: false,
                msgSearching: 'Buscando que facturar... ',
                savingLegalDocument: false
			}
		},
		computed: {
            errors() {
                if(this.objectLegalDocument.issuing_entity_name.trim().length < 3)
                    return true
                if(!this.checkDigitoRUT(this.objectLegalDocument.issuing_entity_document_number))
                    return true
                if(this.objectLegalDocument.issuing_entity_economic_activity.trim().length < 4)
                    return true
                if(this.objectLegalDocument.issuing_entity_address_street.trim().length < 5)
                    return true
                if(this.objectLegalDocument.issuing_entity_address_comuna.trim().length < 3)
                    return true
                if(this.objectLegalDocument.receiving_entity_name.trim().length < 3)
                    return true
                if(!this.checkDigitoRUT(this.objectLegalDocument.receiving_entity_document_number))
                    return true
                if(this.objectLegalDocument.receiving_entity_economic_activity.trim().length < 4)
                    return true
                if(this.objectLegalDocument.receiving_entity_address_street.trim().length < 5)
                    return true
                if(this.objectLegalDocument.receiving_entity_address_comuna.trim().length < 3)
                    return true
                if(this.needReference) {
                    if(this.objectLegalDocument.legal_document_references[0].type_legal_document_id == 0)
                        return true
                    if(this.objectLegalDocument.legal_document_references[0].legal_document_number == 0)
                        return true
                    if(this.objectLegalDocument.legal_document_references[0].date_legal_document == '')
                        return true
                    if(this.objectLegalDocument.legal_document_references[0].code_reference == 0)
                        return true
                    if(this.objectLegalDocument.legal_document_references[0].reason.trim().length < 5)
                        return true
                }
                if(this.objectLegalDocument.total != (this.objectLegalDocument.tax + this.objectLegalDocument.net))
                    return true
                return false
            },
            needReference() {
                let index = this.listTypeLegalDocuments.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectLegalDocument.type_legal_document_id))
                if(index > -1) {
                    return this.listTypeLegalDocuments[index].needReference
                }
                return false
            },
            isNew() {
                return (this.objectLegalDocument.exists == 0)
            }
		},
		methods: {
            getByReceivingEntityDocumentNumberLocal(documentNumber) {
                this.getByReceivingEntityDocumentNumber(documentNumber)
            },
            getByReceivingEntityDocumentNumberResultLocal(response) {
                if(response.data.success === true) {
                    let data = response.data.data
                    this.objectLegalDocument.receiving_entity_name = data.receiving_entity_name
                    this.objectLegalDocument.receiving_entity_economic_activity = data.receiving_entity_economic_activity
                    this.objectLegalDocument.receiving_entity_address_street = data.receiving_entity_address_street
                    this.objectLegalDocument.receiving_entity_address_comuna = data.receiving_entity_address_comuna
                    this.objectLegalDocument.receiving_entity_address_city = data.receiving_entity_address_city
                    this.objectLegalDocument.phone = data.phone
                    this.readonlyReceivingEntityName = true
                } else {
                    this.readonlyReceivingEntityName = false
                    this.$refs.receivingEntityName.click()
                }
            },
            getData() {
                this.searching = true
                this.showLocalDocument(this.urlSearch + '?typeLegalDocumentsId=' + this.typeLegalDocumentsId)
            },
            btnCloseLegalDocumentModalComponent() {
                this.clearObjectLegalDocument()
            },
            btnShowLegalDocumentModalComponent() {
                this.clearObjectLegalDocument()
                this.getData()
            },
            resultAxiosLocal(responseLocal, response) {
                this.$emit('hideLockScreen')
                switch(responseLocal) {
				    case 'getByReceivingEntityDocumentNumberResult': this.getByReceivingEntityDocumentNumberResult(response); break;
                    case 'saveLegalDocumentResult': this.saveLegalDocumentResult(response); break;
                    case 'showLocalDocumentResult': this.showLocalDocumentResult(response); break;
                    default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
                }
            },
            saveLegalDocumentLocal() {
                this.savingLegalDocument = true
                this.saveLegalDocument()
            },
            saveLegalDocumentResultLocal(response) {
                this.dataReturn.id = response.data.data.id
                this.$emit('postSaveLegalDocumentAction', this.dataReturn)
                this.savingLegalDocument = false
            },
            showLocalDocumentResultLocal(response) {
                if(response.data.success === true) {
                    this.searching = false
                    this.objectLegalDocument.date_legal_document = this.currentDate()
                    if(response.data.data.receiving_entity_document_number != '' && this.checkDigitoRUT(response.data.data.receiving_entity_document_number)) {
                        this.getByReceivingEntityDocumentNumberLocal(response.data.data.receiving_entity_document_number)
                    } else if((response.data.data.receiving_entity_document_number == null || response.data.data.receiving_entity_document_number == '') && this.objectLegalDocument.type_legal_document_id == 39) {
                        this.objectLegalDocument.receiving_entity_document_number = '66666666-6'
                        this.getByReceivingEntityDocumentNumberLocal(this.objectLegalDocument.receiving_entity_document_number)
                    }
                    this.dataReturn.table = response.data.message.table
                    this.dataReturn.origenId = response.data.message.id
                } else {
                    this.$emit('errorShowLocalDocument', response)
                }
                
            }
		}
	}
</script>

	<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
